import React from 'react';
import styles from './PersonalInformation.module.scss';

const PersonalInformation = ({ onInputChangedHandler, cvFormData }) => {
    return (
        <fieldset className="form-group">
            <div className="row">
                <div className="col-12 mb-2">
                    <label>
                        <input
                            type="email"
                            className="form-control"
                            value={cvFormData.email}
                            onChange={(event) =>
                                onInputChangedHandler(event, 'email')
                            }
                            placeholder="example@email.com"
                        />
                    </label>
                </div>
                <div className="col-12 mb-2">
                    <label>
                        <input
                            type="text"
                            className="form-control"
                            name="website"
                            placeholder="www.example.com"
                            value={cvFormData.website}
                            onChange={(event) =>
                                onInputChangedHandler(event, 'website')
                            }
                        />
                    </label>
                </div>
                <div className="col-12 mb-2">
                    <label>
                        <input
                            type="tel"
                            className="form-control"
                            name="phone"
                            placeholder="+41 (0) ×× ××× ×× ××"
                            value={cvFormData.phone}
                            onChange={(event) =>
                                onInputChangedHandler(event, 'phone')
                            }
                        />
                    </label>
                </div>
                <div className="col-12 mb-2">
                    <label>
                        <input
                            type="text"
                            className={`form-control ${styles.City}`}
                            name="city"
                            placeholder="City"
                            value={cvFormData.city}
                            onChange={(event) =>
                                onInputChangedHandler(event, 'city')
                            }
                        />
                    </label>
                    ,
                    <label>
                        <input
                            type="text"
                            className={`form-control ${styles.Country}`}
                            name="countryCode"
                            placeholder="Country"
                            value={cvFormData.country}
                            onChange={(event) =>
                                onInputChangedHandler(event, 'country')
                            }
                        />
                    </label>
                </div>
            </div>
        </fieldset>
    );
};

export default PersonalInformation;
